// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__28DgP","col":"styles_col__u3ZzZ"};